import React, { Component } from 'react';
// import { Link } from 'react-router-dom';
// import axios from 'axios';
// import { decode } from 'html-entities';
import Moment from 'react-moment';
import 'moment-timezone';
import { stripFileLinks } from '../../utils/sanitizeHtml';

export class List extends Component  {
  state = { events: [], limit: null, loadmore: false }

  componentDidMount() {
    this.setState({
      events: this.props.events,
      limit: this.props.limit,
      loadmore: this.props.loadmore
    });
  }

  handleDateClick = (e) => {
    console.log(e.target.dataset.eventid);
    window.location.href = '/event?eventid=' + e.target.dataset.eventid;
  }

  loadMore = () => {
    let l = Number(this.state.limit) + 5;
    let max = Number(this.state.events.length);

    if (l < max) {
      this.setState({ limit: l });
    } else {
      this.setState({ limit: l, loadmore: false });
    }
  }

  render() {
    const { events, limit, loadmore } = this.state;
    // console.dir(events);
    // console.dir(limit);

    return (
      <>
        <section className="eventListCont">
          {events.slice(0,limit).map((e, index) =>
            <div className="event" key={ index } onClick={ this.handleDateClick } data-eventid={ e.id }>
              <div className="img" style={{ backgroundImage: 'url('+e.featured_image+')' }}></div>

              <div className="content">
                <h3>{ e.title }</h3>
                <div className="dateTime">
                  <Moment date={ e.start } format='dddd, MMMM DD, YYYY' /> - <Moment date={ e.start } format='hh:mm a z' tz='America/Los_Angeles' /> / <Moment date={ e.start } format='hh:mm a z' tz='America/Chicago' /> / <Moment date={ e.start } format='hh:mm a z' tz='America/New_York' />
                </div>

                <div className="data">
                  <div className="presenter">
                    {e.presenter && (
                      <><i className="fa fa-user"></i> Presenter: { e.presenter }</>
                    )}
                  </div>

                  <div className="seats">
                    {e.seats && (
                      <><i className="fa fa-users"></i> { e.seats - e.seats_taken } of { e.seats } seats available</>
                    )}
                  </div>
                </div>

                <div className="description" dangerouslySetInnerHTML={{ __html: stripFileLinks(e.description.split(/\n/)[0]) }} />
                <div className="rm">
                  <span className="readMore">Read more and begin registration today <i className="fa fa-arrow-circle-right"></i></span>
                </div>
              </div>
            </div>
          )}

          {loadmore && (
            <button onClick={ this.loadMore } className="loadmore">Load More</button>
          )}
        </section>
      </>
    );
  }
}

export default List;